import { useEffect, useState } from "react";
import { FileDown, FileText } from "lucide-react";
import { api } from "../../api";
import PageHeader from "../../components/PageHeader";
import { Button } from "../../components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { toast } from "sonner";

export default function Availability() {
  const [countries, setCountries] = useState([]);
  const [countryId, setCountryId] = useState("__base__");
  useEffect(() => { api.get("/countries").then((r) => setCountries(r.data)); }, []);

  const download = async (format) => {
    const params = new URLSearchParams({ format });
    if (countryId !== "__base__") params.set("country_id", countryId);
    const token = localStorage.getItem("db_token");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/availability?${params}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("bad status");
      const blob = await res.blob();
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob); a.download = `availability.${format}`; a.click();
    } catch { toast.error("Download failed"); }
  };

  return (
    <>
      <PageHeader title="Availability export" subtitle="Send buyers a current price list — CSV for data, PDF for a clean handout." testid="page-availability" />
      <div className="p-6 max-w-2xl bg-white border border-[#E2E4E0] rounded-lg m-6">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_auto] items-end gap-3">
          <div>
            <label className="text-xs text-[#5C665A]">Pricing for country</label>
            <Select value={countryId} onValueChange={setCountryId}>
              <SelectTrigger className="h-10" data-testid="availability-country"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="__base__">Base prices (no country adjustment)</SelectItem>
                {countries.map((c) => <SelectItem key={c.id} value={c.id}>{c.name} ({c.percent_adjustment >= 0 ? "+" : ""}{c.percent_adjustment}%)</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          <Button data-testid="availability-csv" onClick={() => download("csv")} variant="outline" className="h-10"><FileDown size={14} /> CSV</Button>
          <Button data-testid="availability-pdf" onClick={() => download("pdf")} className="h-10 bg-[#2D6A4F] hover:bg-[#1B4332] text-white"><FileText size={14} /> PDF</Button>
        </div>
        <p className="text-xs text-[#5C665A] mt-4">
          Only <span className="font-medium">published</span> products are included. Prices are EUR, VAT-exclusive.
        </p>
      </div>
    </>
  );
}
